module.exports = __webpack_public_path__ + "static/media/main2.9f0e3829.svg";